import { HubLayoutConstants } from '../../../globals/hubConstants';

export default function getProgressLink(singleClassRoute, orgId) {
  return `${singleClassRoute}${HubLayoutConstants.PATH_NAMES.PROGRESS}/${orgId}${HubLayoutConstants.PATH_NAMES.GRADEBOOK}`;
}
